import { render } from "./evaLessonDetail.vue?vue&type=template&id=390e2e51&scoped=true"
import script from "./evaLessonDetail.vue?vue&type=script&lang=js"
export * from "./evaLessonDetail.vue?vue&type=script&lang=js"

import "./evaLessonDetail.vue?vue&type=style&index=0&id=390e2e51&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390e2e51"]])

export default __exports__